import { render, staticRenderFns } from "./SfTabs.vue?vue&type=template&id=5ab4b852"
import script from "./SfTabs.vue?vue&type=script&lang=js"
export * from "./SfTabs.vue?vue&type=script&lang=js"
import style0 from "./SfTabs.vue?vue&type=style&index=0&id=5ab4b852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports